import script from "./OurServicesArticleSection.vue?vue&type=script&setup=true&lang=js"
export * from "./OurServicesArticleSection.vue?vue&type=script&setup=true&lang=js"

import "./OurServicesArticleSection.vue?vue&type=style&index=0&id=cf63d762&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf63d762"]])

export default __exports__